module.exports = __webpack_public_path__ + "static/img/subject_bg5.d5f9268c.png";